import { Link } from 'react-router-dom'
import clsx from 'clsx'
import { checkIsActive } from '../../../../helpers'

type Props = {
  to: string
  activePath: string
  pathname: string
  icon: string
  label: string
  isFirst?: boolean
  excludeActivePaths?: string[]
}

const SidebarSubmenuLink = ({
  to,
  activePath,
  pathname,
  icon,
  label,
  isFirst = false,
  excludeActivePaths = [],
}: Props) => {
  const isActive =
    checkIsActive(pathname, activePath) &&
    !excludeActivePaths.some((path) => checkIsActive(pathname, path))

  return (
    <Link
      to={to}
      className={clsx(
        !isFirst && 'mt-1',
        'flex w-full items-center gap-3 px-3 py-2 rounded-lg fs-13 text-white font-medium no-underline transition-colors',
        isActive
          ? 'bg-white/10 text-white'
            : 'text-gray-400 hover:bg-white/10 hover:text-white'
      )}
    >
      <img
        src={icon}
        className={clsx(
          'h-4 w-4 shrink-0 object-contain brightness-0 invert',
          isActive ? 'opacity-100' : 'opacity-60'
        )}
        height={16}
        width={16}
        alt=''
      />
      <span>{label}</span>
    </Link>
  )
}

export { SidebarSubmenuLink }
